import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import LabelText from '../../LabelText';
import TextareaAutosize from 'react-textarea-autosize';
import RatingInput from './Input';

const Rating = (props) => {
	const { t, i18n } = useTranslation();

	const {form_component} = props;

	const fv = useSelector(state => state.fv);

	const userData = useSelector(state => state.userData);

	useEffect(() => { // to be updated after render
		i18n.changeLanguage(props.lang);
	}, []);

	useEffect(() => { // to be updated after render
		if (fv && form_component.required) {
			form_component.rating.rating_label.map((rating_label, index) => {
				var validator = {
					validators: {
						notEmpty: {
							message: t('此欄為必須填寫')
						}
					}
				};

				fv.addField(form_component.fieldname[index], validator);
			});
		}
	}, [fv]);

	return (
		<div className={`flex-grow-1 form-group text ${form_component.required ? 'required' : ''}`}>
			<LabelText
				lang={props.lang}
				form_component={form_component}
			/>
			<div className="sub-quest-box position-relative">
				<div className="score-level  ms-auto">
					<div className="w-200px score-level__empty p-xl-3"></div>
					<div className="score-level__scales">
						<div className="d-flex gap-2 flex-grow-1 p-3 text-gray-700">
							{(() => {
								const components = [];
								
								form_component.rating.rating_label.map((rating_label, index) => {
									components.push(
										<div key={`rating-label-${index}`} className="col px-3 text-center">
											{rating_label}
										</div>
									);
								});

								return components;
							})()}
						</div>
					</div>
				</div>
				{(() => {
					const components = [];
					
					form_component.rating.sub_questions.map((sub_question, index) => {
						if (index > 0) {
							components.push(
								<div key={`sub-question-separator-${index}`} className="my-1"></div>
							);
						}
						components.push(
							<div key={`sub-question-${index}`} className="sub-quest w-100 form-group">
								<span className="sub-quest__title  p-xl-3">{sub_question.label}</span>
								<div className="label_box label-matrix ">
									<div className="d-flex gap-2 p-xl-3 flex-column flex-xl-row flex-grow-1">
										{!form_component.required && (
											<input type="hidden" name={`${form_component.fieldname}[${index}]`} value="" />
										)}
										{(() => {
											const components2 = [];
											
											form_component.rating.rating_label.map((rating_label, index2) => {
												components2.push(
													<RatingInput
														key={`rating-input-${index2}`}
														lang={props.lang}
														form_component={form_component}
														index={index}
														index2={index2}
														sub_question={sub_question}
														rating_label={rating_label}
													/>
												);
											});

											return components2;
										})()}
									</div>
								</div>
							</div>
						);
					});

					return components;
				})()}
			</div>
		</div>
	);
}

export default Rating;